/**
 * Footer entrance.
 *
 * Runs the reveal once, the first time the footer reaches the viewport. The
 * sequence itself is CSS; this only decides when it starts.
 */
class RanaFooter extends HTMLElement {
  connectedCallback() {
    // Marks that the script is running. The CSS only hides content once this
    // class is present, so a script that never loads leaves the footer plainly
    // visible rather than blank.
    this.classList.add('is-ready');

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      this.classList.add('is-in');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-in');
          // Once per page load.
          this.observer?.disconnect();
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('rana-footer')) {
  customElements.define('rana-footer', RanaFooter);
}
